module.exports = __webpack_public_path__ + "static/img/SFU老师_Mark.204478d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Mark.png
// module id = 6nna
// module chunks = 0